function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e) {
  var n = {};

  function o(t) {
    if (n[t]) return n[t].exports;
    var a = n[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return e[t].call(a.exports, a, a.exports, o), a.l = !0, a.exports;
  }

  o.m = e, o.c = n, o.d = function (e, n, t) {
    o.o(e, n) || Object.defineProperty(e, n, {
      enumerable: !0,
      get: t
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (e, n) {
    if (1 & n && (e = o(e)), 8 & n) return e;
    if (4 & n && "object" == _typeof(e) && e && e.__esModule) return e;
    var t = Object.create(null);
    if (o.r(t), Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    }), 2 & n && "string" != typeof e) for (var a in e) {
      o.d(t, a, function (n) {
        return e[n];
      }.bind(null, a));
    }
    return t;
  }, o.n = function (e) {
    var n = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return o.d(n, "a", n), n;
  }, o.o = function (e, n) {
    return Object.prototype.hasOwnProperty.call(e, n);
  }, o.p = "", o(o.s = 9);
}([function (e, n, o) {
  var t, a;
  /*!
   * JavaScript Cookie v2.2.1
   * https://github.com/js-cookie/js-cookie
   *
   * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
   * Released under the MIT license
   */

  !function (r) {
    if (void 0 === (a = "function" == typeof (t = r) ? t.call(n, o, n, e) : t) || (e.exports = a), !0, e.exports = r(), !!0) {
      var i = window.Cookies,
          d = window.Cookies = r();

      d.noConflict = function () {
        return window.Cookies = i, d;
      };
    }
  }(function () {
    function e() {
      for (var e = 0, n = {}; e < arguments.length; e++) {
        var o = arguments[e];

        for (var t in o) {
          n[t] = o[t];
        }
      }

      return n;
    }

    function n(e) {
      return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }

    return function o(t) {
      function a() {}

      function r(n, o, r) {
        if ("undefined" != typeof document) {
          "number" == typeof (r = e({
            path: "/"
          }, a.defaults, r)).expires && (r.expires = new Date(1 * new Date() + 864e5 * r.expires)), r.expires = r.expires ? r.expires.toUTCString() : "";

          try {
            var i = JSON.stringify(o);
            /^[\{\[]/.test(i) && (o = i);
          } catch (e) {}

          o = t.write ? t.write(o, n) : encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), n = encodeURIComponent(String(n)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var d = "";

          for (var c in r) {
            r[c] && (d += "; " + c, !0 !== r[c] && (d += "=" + r[c].split(";")[0]));
          }

          return document.cookie = n + "=" + o + d;
        }
      }

      function i(e, o) {
        if ("undefined" != typeof document) {
          for (var a = {}, r = document.cookie ? document.cookie.split("; ") : [], i = 0; i < r.length; i++) {
            var d = r[i].split("="),
                c = d.slice(1).join("=");
            o || '"' !== c.charAt(0) || (c = c.slice(1, -1));

            try {
              var l = n(d[0]);
              if (c = (t.read || t)(c, l) || n(c), o) try {
                c = JSON.parse(c);
              } catch (e) {}
              if (a[l] = c, e === l) break;
            } catch (e) {}
          }

          return e ? a[e] : a;
        }
      }

      return a.set = r, a.get = function (e) {
        return i(e, !1);
      }, a.getJSON = function (e) {
        return i(e, !0);
      }, a.remove = function (n, o) {
        r(n, "", e(o, {
          expires: -1
        }));
      }, a.defaults = {}, a.withConverter = o, a;
    }(function () {});
  });
}, function (e, n) {
  e.exports = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" class="__3aRnPxc__svg-inline--fa __3aRnPxc__fa-chevron-down __3aRnPxc__fa-w-14 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>';
}, function (e, n, o) {
  "use strict";

  e.exports = function (e) {
    var n = [];
    return n.toString = function () {
      return this.map(function (n) {
        var o = function (e, n) {
          var o = e[1] || "",
              t = e[3];
          if (!t) return o;

          if (n && "function" == typeof btoa) {
            var a = (i = t, d = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(d), "/*# ".concat(c, " */")),
                r = t.sources.map(function (e) {
              return "/*# sourceURL=".concat(t.sourceRoot || "").concat(e, " */");
            });
            return [o].concat(r).concat([a]).join("\n");
          }

          var i, d, c;
          return [o].join("\n");
        }(n, e);

        return n[2] ? "@media ".concat(n[2], " {").concat(o, "}") : o;
      }).join("");
    }, n.i = function (e, o, t) {
      "string" == typeof e && (e = [[null, e, ""]]);
      var a = {};
      if (t) for (var r = 0; r < this.length; r++) {
        var i = this[r][0];
        null != i && (a[i] = !0);
      }

      for (var d = 0; d < e.length; d++) {
        var c = [].concat(e[d]);
        t && a[c[0]] || (o && (c[2] ? c[2] = "".concat(o, " and ").concat(c[2]) : c[2] = o), n.push(c));
      }
    }, n;
  };
}, function (e, n) {
  window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = function (e, n) {
    n = n || window;

    for (var o = 0; o < this.length; o++) {
      e.call(n, this[o], o, this);
    }
  });
}, function (e, n) {
  String.prototype.endsWith || (String.prototype.endsWith = function (e, n) {
    return (void 0 === n || n > this.length) && (n = this.length), this.substring(n - e.length, n) === e;
  });
}, function (e, n, o) {
  var t = o(6),
      a = o(7);
  "string" == typeof (a = a.__esModule ? a["default"] : a) && (a = [[e.i, a, ""]]);
  var r = {
    insert: "head",
    singleton: !1
  };
  t(a, r);
  e.exports = a.locals || {};
}, function (e, n, o) {
  "use strict";

  var t,
      a = function a() {
    return void 0 === t && (t = Boolean(window && document && document.all && !window.atob)), t;
  },
      r = function () {
    var e = {};
    return function (n) {
      if (void 0 === e[n]) {
        var o = document.querySelector(n);
        if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) try {
          o = o.contentDocument.head;
        } catch (e) {
          o = null;
        }
        e[n] = o;
      }

      return e[n];
    };
  }(),
      i = [];

  function d(e) {
    for (var n = -1, o = 0; o < i.length; o++) {
      if (i[o].identifier === e) {
        n = o;
        break;
      }
    }

    return n;
  }

  function c(e, n) {
    for (var o = {}, t = [], a = 0; a < e.length; a++) {
      var r = e[a],
          c = n.base ? r[0] + n.base : r[0],
          l = o[c] || 0,
          s = "".concat(c, " ").concat(l);
      o[c] = l + 1;
      var m = d(s),
          u = {
        css: r[1],
        media: r[2],
        sourceMap: r[3]
      };
      -1 !== m ? (i[m].references++, i[m].updater(u)) : i.push({
        identifier: s,
        updater: b(u, n),
        references: 1
      }), t.push(s);
    }

    return t;
  }

  function l(e) {
    var n = document.createElement("style"),
        t = e.attributes || {};

    if (void 0 === t.nonce) {
      var a = o.nc;
      a && (t.nonce = a);
    }

    if (Object.keys(t).forEach(function (e) {
      n.setAttribute(e, t[e]);
    }), "function" == typeof e.insert) e.insert(n);else {
      var i = r(e.insert || "head");
      if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
      i.appendChild(n);
    }
    return n;
  }

  var s,
      m = (s = [], function (e, n) {
    return s[e] = n, s.filter(Boolean).join("\n");
  });

  function u(e, n, o, t) {
    var a = o ? "" : t.media ? "@media ".concat(t.media, " {").concat(t.css, "}") : t.css;
    if (e.styleSheet) e.styleSheet.cssText = m(n, a);else {
      var r = document.createTextNode(a),
          i = e.childNodes;
      i[n] && e.removeChild(i[n]), i.length ? e.insertBefore(r, i[n]) : e.appendChild(r);
    }
  }

  function A(e, n, o) {
    var t = o.css,
        a = o.media,
        r = o.sourceMap;
    if (a ? e.setAttribute("media", a) : e.removeAttribute("media"), r && btoa && (t += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), e.styleSheet) e.styleSheet.cssText = t;else {
      for (; e.firstChild;) {
        e.removeChild(e.firstChild);
      }

      e.appendChild(document.createTextNode(t));
    }
  }

  var f = null,
      h = 0;

  function b(e, n) {
    var o, t, a;

    if (n.singleton) {
      var r = h++;
      o = f || (f = l(n)), t = u.bind(null, o, r, !1), a = u.bind(null, o, r, !0);
    } else o = l(n), t = A.bind(null, o, n), a = function a() {
      !function (e) {
        if (null === e.parentNode) return !1;
        e.parentNode.removeChild(e);
      }(o);
    };

    return t(e), function (n) {
      if (n) {
        if (n.css === e.css && n.media === e.media && n.sourceMap === e.sourceMap) return;
        t(e = n);
      } else a();
    };
  }

  e.exports = function (e, n) {
    (n = n || {}).singleton || "boolean" == typeof n.singleton || (n.singleton = a());
    var o = c(e = e || [], n);
    return function (e) {
      if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
        for (var t = 0; t < o.length; t++) {
          var a = d(o[t]);
          i[a].references--;
        }

        for (var r = c(e, n), l = 0; l < o.length; l++) {
          var s = d(o[l]);
          0 === i[s].references && (i[s].updater(), i.splice(s, 1));
        }

        o = r;
      }
    };
  };
}, function (e, n, o) {
  "use strict";

  o.r(n);
  var t = o(2),
      a = o.n(t)()(!0);
  a.push([e.i, '.d-cc--modal-open{overflow:hidden}.d-cc--modal-open .d-cc--modal{overflow-x:hidden;overflow-y:auto}.d-cc--modal{position:fixed;top:0;left:0;z-index:1050;display:none;width:100%;height:100%;overflow:hidden;outline:0}.d-cc--modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.d-cc--modal.fade .d-cc--modal-dialog{transition:transform .3s ease-out;transform:translate(0, -50px)}@media(prefers-reduced-motion: reduce){.d-cc--modal.fade .d-cc--modal-dialog{transition:none}}.d-cc--modal.show .d-cc--modal-dialog{transform:none}.d-cc--modal-dialog-scrollable{display:flex;max-height:calc(100% - 1rem)}.d-cc--modal-dialog-scrollable .d-cc--modal-content{max-height:calc(100vh - 1rem);overflow:hidden}.d-cc--modal-dialog-scrollable .d-cc--modal-header,.d-cc--modal-dialog-scrollable .d-cc--modal-footer{flex-shrink:0}.d-cc--modal-dialog-scrollable .d-cc--modal-body{overflow-y:auto}.d-cc--modal-dialog-centered{display:flex;align-items:center;min-height:calc(100% - 1rem)}.d-cc--modal-dialog-centered::before{display:block;height:calc(100vh - 1rem);content:""}.d-cc--modal-dialog-centered.d-cc--modal-dialog-scrollable{flex-direction:column;justify-content:center;height:100%}.d-cc--modal-dialog-centered.d-cc--modal-dialog-scrollable .d-cc--modal-content{max-height:none}.d-cc--modal-dialog-centered.d-cc--modal-dialog-scrollable::before{content:none}.d-cc--modal-content{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.d-cc--modal-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.d-cc--modal-backdrop.fade{opacity:0}.d-cc--modal-backdrop.show{opacity:.5}.d-cc--modal-header{display:flex;align-items:flex-start;justify-content:space-between;padding:1rem 1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(0.3rem - 1px);border-top-right-radius:calc(0.3rem - 1px)}.d-cc--modal-header .close{padding:1rem 1rem;margin:-1rem -1rem -1rem auto}.d-cc--modal-title{margin-bottom:0;line-height:1.5}.d-cc--modal-body{position:relative;flex:1 1 auto;padding:1rem}.d-cc--modal-footer{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(0.3rem - 1px);border-bottom-left-radius:calc(0.3rem - 1px)}.d-cc--modal-footer>*{margin:.25rem}@media(min-width: 576px){.d-cc--modal-dialog{max-width:500px;margin:1.75rem auto}.d-cc--modal-dialog-scrollable{max-height:calc(100% - 3.5rem)}.d-cc--modal-dialog-scrollable .d-cc--modal-content{max-height:calc(100vh - 3.5rem)}.d-cc--modal-dialog-centered{min-height:calc(100% - 3.5rem)}.d-cc--modal-dialog-centered::before{height:calc(100vh - 3.5rem)}}@media(min-width: 992px){.d-cc--modal-lg{max-width:800px}}.d-cc--card{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.d-cc--card>hr{margin-right:0;margin-left:0}.d-cc--card>.list-group:first-child .list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.d-cc--card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.d-cc--card-body{flex:1 1 auto;min-height:1px;padding:1.25rem}.d-cc--card-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.d-cc--card-header:first-child{border-radius:calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0}.d-cc--accordion>.d-cc--card{overflow:hidden}.d-cc--accordion>.d-cc--card:not(:last-of-type){border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.d-cc--accordion>.d-cc--card:not(:first-of-type){border-top-left-radius:0;border-top-right-radius:0}.d-cc--accordion>.d-cc--card>.d-cc--card-header{border-radius:0;margin-bottom:-1px}.d-cc--modal h1,.d-cc--modal h2,.d-cc--modal h3,.d-cc--modal h4,.d-cc--modal h5,.d-cc--modal h6{margin-top:0;margin-bottom:.5rem}.d-cc--modal h1.d-cc--modal-title,.d-cc--modal h2.d-cc--modal-title,.d-cc--modal h3.d-cc--modal-title,.d-cc--modal h4.d-cc--modal-title,.d-cc--modal h5.d-cc--modal-title,.d-cc--modal h6.d-cc--modal-title{margin-bottom:0}.d-cc--modal-backdrop{opacity:.5}.d-cc--modal-title{font-weight:400;font-size:19px;text-transform:none}.d-cc--modal-body{font-weight:300;font-size:15px;line-height:1.6;color:#838386;background-color:#fff}.d-cc--checkboxes{display:flex;flex-direction:row;justify-content:space-between;margin-bottom:1em}.d-cc--checkboxes label{color:#000;display:inline}.d-cc--checkboxes input{margin:0}.d-cc--checkboxes div{width:50%}.d-cc--modal-footer{flex-direction:column;align-items:flex-end;margin:0;width:initial;height:auto}.d-cc--card-header{padding:0}.d-cc--card-header h2{margin-bottom:0;line-height:1}.d-cc--card-header button{width:100%}.d-cc--card-header button:focus,.d-cc--card-header button:active,.d-cc--card-header button:focus:active{outline:none}.icon-svg svg{height:1rem;vertical-align:middle}', "", {
    version: 3,
    sources: ["/home/timo/src/digineo/cookie-consent/src/styles/_modal.scss", "/home/timo/src/digineo/cookie-consent/src/styles.scss", "/home/timo/src/digineo/cookie-consent/src/styles/_transition.scss", "/home/timo/src/digineo/cookie-consent/src/styles/_border-radius.scss", "/home/timo/src/digineo/cookie-consent/src/styles/_breakpoints.scss", "/home/timo/src/digineo/cookie-consent/src/styles/_card.scss"],
    names: [],
    mappings: "AAMA,kBAEE,eAAA,CAEA,+BACE,iBAAA,CACA,eAAA,CAKJ,aACE,cAAA,CACA,KAAA,CACA,MAAA,CACA,YCnBkC,CDoBlC,YAAA,CACA,UAAA,CACA,WAAA,CACA,eAAA,CAGA,SAAA,CAOF,oBACE,iBAAA,CACA,UAAA,CACA,YCGkC,CDDlC,mBAAA,CAGA,sCErCI,iCFsCF,CACA,6BCuBgC,CCzDhC,uCFgCF,sCE/BI,eAAA,CAAA,CFmCJ,sCACE,cCqBgC,CDjBpC,+BACE,YAAA,CACA,4BAAA,CAEA,oDACE,6BAAA,CACA,eAAA,CAGF,sGAEE,aAAA,CAGF,iDACE,eAAA,CAIJ,6BACE,YAAA,CACA,kBAAA,CACA,4BAAA,CAGA,qCACE,aAAA,CACA,yBAAA,CACA,UAAA,CAIF,2DACE,qBAAA,CACA,sBAAA,CACA,WAAA,CAEA,gFACE,eAAA,CAGF,mEACE,YAAA,CAMN,qBACE,iBAAA,CACA,YAAA,CACA,qBAAA,CACA,UAAA,CAGA,mBAAA,CACA,qBCtGS,CDuGT,2BAAA,CACA,+BAAA,CGzGE,mBFO0B,CDsG5B,SAAA,CAIF,sBACE,cAAA,CACA,KAAA,CACA,MAAA,CACA,YCvHsB,CDwHtB,WAAA,CACA,YAAA,CACA,qBCrHS,CDwHT,2BAAA,SAAA,CACA,2BAAA,UCzEkC,CD8EpC,oBACE,YAAA,CACA,sBAAA,CACA,6BAAA,CACA,iBC3EkC,CD4ElC,+BAAA,CG7HE,yCFqCgC,CEpChC,0CFoCgC,CD2FlC,2BACE,iBChFgC,CDkFhC,6BAAA,CAKJ,mBACE,eAAA,CACA,eCnJ4B,CDwJ9B,kBACE,iBAAA,CAGA,aAAA,CACA,YC9HkC,CDkIpC,oBACE,YAAA,CACA,cAAA,CACA,kBAAA,CACA,wBAAA,CACA,cAAA,CACA,4BAAA,CGhJE,6CFuBgC,CEtBhC,4CFsBgC,CDgIlC,sBACE,aAAA,CI9JA,yBJqKF,oBACE,eC1HgC,CD2HhC,mBAAA,CAGF,+BACE,8BAAA,CAEA,oDACE,+BAAA,CAIJ,6BACE,8BAAA,CAEA,qCACE,2BAAA,CAAA,CItLF,yBJgMF,gBACE,eCtJgC,CAAA,CI7DpC,YACE,iBAAA,CACA,YAAA,CACA,qBAAA,CACA,WAAA,CAEA,oBAAA,CACA,qBJLS,CIMT,0BAAA,CACA,iCAAA,CFRE,oBFM0B,CIK5B,eACE,cAAA,CACA,aAAA,CAIA,iEFRA,6BFH0B,CEI1B,8BFJ0B,CIiB1B,+DAAA,iCJjB0B,CEkB1B,gCFlB0B,CIuB9B,iBAGE,aAAA,CAGA,cAAA,CACA,eJgCkC,CIvBpC,mBACE,sBAAA,CACA,eAAA,CAEA,gCJwBkC,CIvBlC,wCAAA,CAEA,+BFpDE,yDEqDuB,CASzB,6BACE,eAAA,CAEA,gDACE,eAAA,CF3CF,4BE4CgC,CF3ChC,2BE2CgC,CAGhC,iDF7DA,wBE8D6B,CF7D7B,yBE6D6B,CAG7B,gDF1EA,eE2EyB,CACvB,kBAAA,CJkBJ,gGACE,YAAA,CACA,mBApE0B,CAsE1B,4MACE,eAAA,CAKN,sBACE,UAAA,CAGF,mBACE,eAAA,CACA,cAAA,CACA,mBAAA,CAGF,kBACE,eAAA,CACA,cAAA,CACA,eAAA,CACA,aAAA,CACA,qBAAA,CAGF,kBAUE,YAAA,CACA,kBAAA,CACA,6BAAA,CAMA,iBAAA,CAjBA,wBACE,UAAA,CACA,cAAA,CAGF,wBACE,QAAA,CAOF,sBACE,SAAA,CAMJ,oBACE,qBAAA,CACA,oBAAA,CACA,QAAA,CACA,aAAA,CACA,WAAA,CAGF,mBACE,SAAA,CAEA,sBACE,eAAA,CACA,aAAA,CAGF,0BACE,UAAA,CAEA,wGACE,YAAA,CAKN,cACE,WA3J4B,CA4J5B,qBAAA",
    file: "styles.scss",
    sourcesContent: ["// .d-cc--modal-open      - body class for killing the scroll\n// .d-cc--modal           - container to scroll within\n// .d-cc--modal-dialog    - positioning shell for the actual modal\n// .d-cc--modal-content   - actual modal w/ bg and corners and stuff\n\n\n.d-cc--modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .d-cc--modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.d-cc--modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.d-cc--modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .d-cc--modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .d-cc--modal.show & {\n    transform: $modal-show-transform;\n  }\n}\n\n.d-cc--modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .d-cc--modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .d-cc--modal-header,\n  .d-cc--modal-footer {\n    flex-shrink: 0;\n  }\n\n  .d-cc--modal-body {\n    overflow-y: auto;\n  }\n}\n\n.d-cc--modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    content: \"\";\n  }\n\n  // Ensure `.d-cc--modal-body` shows scrollbar (IE10/11)\n  &.d-cc--modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .d-cc--modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.d-cc--modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.d-cc--modal-content` extends the full width of the parent `.d-cc--modal-dialog`\n  // counteract the pointer-events: none; in the .d-cc--modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.d-cc--modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.d-cc--modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .d-cc--modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.d-cc--modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .d-cc--modal-header and .d-cc--modal-footer)\n.d-cc--modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.d-cc--modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.d-cc--modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between / 2;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  // stylelint-disable-next-line selector-max-universal\n  > * {\n    margin: $modal-footer-margin-between / 2;\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .d-cc--modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .d-cc--modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .d-cc--modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .d-cc--modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .d-cc--modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .d-cc--modal-lg {\n    max-width: $modal-lg;\n  }\n}\n", '@import "./styles/functions";\n\n$zindex-modal:                      1050 !default;\n$zindex-modal-backdrop: 1040;\n\n$line-height-base:            1.5 !default;\n$white:    #fff !default;\n$gray-300: #dee2e6 !default;\n$black:    #000 !default;\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$grid-breakpoints: (\n        xs: 0,\n        sm: 576px,\n        md: 768px,\n        lg: 992px,\n        xl: 1200px\n) !default;\n$grid-gutter-width:           30px !default;\n\n$spacer: 1rem !default;\n$headings-margin-bottom:      $spacer / 2 !default;\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n@import "./styles/transition";\n@import "./styles/border-radius";\n@import "./styles/box-shadow";\n@import "./styles/breakpoints";\n@import "./styles/modal";\n@import "./styles/hover";\n@import "./styles/card";\n\n// reset\n.d-cc--modal {\n  // Remove top margins from headings\n  //\n  // By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n  // margin for easier control within type scales as it avoids margin collapsing.\n  // stylelint-disable-next-line selector-list-comma-newline-after\n  h1, h2, h3, h4, h5, h6 {\n    margin-top: 0;\n    margin-bottom: $headings-margin-bottom;\n\n    &.d-cc--modal-title {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.d-cc--modal-backdrop {\n  opacity: .5;\n}\n\n.d-cc--modal-title {\n  font-weight: 400;\n  font-size: 19px;\n  text-transform: none;\n}\n\n.d-cc--modal-body {\n  font-weight: 300;\n  font-size: 15px;\n  line-height: 1.6;\n  color: #838386;\n  background-color: #ffffff;\n}\n\n.d-cc--checkboxes {\n  label {\n    color: black;\n    display: inline;\n  }\n\n  input {\n    margin: 0;\n  }\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  div {\n    width: 50%;\n  }\n\n  margin-bottom: 1em;\n}\n\n.d-cc--modal-footer {\n  flex-direction: column;\n  align-items: flex-end;\n  margin: 0;\n  width: initial;\n  height: auto;\n}\n\n.d-cc--card-header {\n  padding: 0;\n\n  h2 {\n    margin-bottom: 0;\n    line-height: 1;\n  }\n\n  button {\n    width: 100%;\n\n    &:focus, &:active, &:focus:active {\n      outline: none;\n    }\n  }\n}\n\n.icon-svg svg {\n  height: $font-size-base;\n  vertical-align: middle;\n}\n', "// stylelint-disable property-blacklist\n@mixin transition($transition...) {\n  @if $enable-transitions {\n    @if length($transition) == 0 {\n      transition: $transition-base;\n    } @else {\n      transition: $transition;\n    }\n  }\n\n  @if $enable-prefers-reduced-motion-media-query {\n    @media (prefers-reduced-motion: reduce) {\n      transition: none;\n    }\n  }\n}\n", "// stylelint-disable property-blacklist\n// Single side border-radius\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: $radius;\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: $radius;\n    border-top-right-radius: $radius;\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: $radius;\n    border-bottom-right-radius: $radius;\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: $radius;\n    border-bottom-left-radius: $radius;\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: $radius;\n    border-bottom-left-radius: $radius;\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: $radius;\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: $radius;\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: $radius;\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: $radius;\n  }\n}\n", "// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n", "//\n// Base styles\n//\n\n.d-cc--card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group:first-child {\n    .list-group-item:first-child {\n      @include border-top-radius($card-border-radius);\n    }\n  }\n\n  > .list-group:last-child {\n    .list-group-item:last-child {\n      @include border-bottom-radius($card-border-radius);\n    }\n  }\n}\n\n.d-cc--card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n\n//\n// Optional textual caps\n//\n\n.d-cc--card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n//\n// Accordion\n//\n\n.d-cc--accordion {\n  > .d-cc--card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .d-cc--card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n"]
  }]), n["default"] = a;
}, function (e, n) {
  "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
    value: function value(e, n) {
      if (null == e) throw new TypeError("Cannot convert undefined or null to object");

      for (var o = Object(e), t = 1; t < arguments.length; t++) {
        var a = arguments[t];
        if (null != a) for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (o[r] = a[r]);
        }
      }

      return o;
    },
    writable: !0,
    configurable: !0
  });
}, function (e, n, o) {
  "use strict";

  o.r(n);
  o(3), o(4), o(5), o(8);
  var t = o(0),
      a = o.n(t);

  function r(e, n) {
    var o;

    if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
      if (Array.isArray(e) || (o = function (e, n) {
        if (!e) return;
        if ("string" == typeof e) return i(e, n);
        var o = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === o && e.constructor && (o = e.constructor.name);
        if ("Map" === o || "Set" === o) return Array.from(e);
        if ("Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)) return i(e, n);
      }(e)) || n && e && "number" == typeof e.length) {
        o && (e = o);

        var t = 0,
            a = function a() {};

        return {
          s: a,
          n: function n() {
            return t >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[t++]
            };
          },
          e: function e(_e) {
            throw _e;
          },
          f: a
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var r,
        d = !0,
        c = !1;
    return {
      s: function s() {
        o = e[Symbol.iterator]();
      },
      n: function n() {
        var e = o.next();
        return d = e.done, e;
      },
      e: function e(_e2) {
        c = !0, r = _e2;
      },
      f: function f() {
        try {
          d || null == o["return"] || o["return"]();
        } finally {
          if (c) throw r;
        }
      }
    };
  }

  function i(e, n) {
    (null == n || n > e.length) && (n = e.length);

    for (var o = 0, t = new Array(n); o < n; o++) {
      t[o] = e[o];
    }

    return t;
  }

  var d = {
    onMarketingChanged: function onMarketingChanged() {},
    bootstrapMarketing: function bootstrapMarketing() {},
    cookieExpiration: 30,
    cookies: {},
    cookieDomain: document.location.hostname,
    siteNoticeUrl: "/impressum",
    privacyUrl: "/datenschutz",
    locale: "de",
    enabled: !0
  },
      c = a.a.getJSON("consent") || {
    version: 0,
    marketing: 0
  };
  var l = {
    get config() {
      return this._config = this._config || Object.assign({}, d, window.DCCconfig);
    },

    get mustShowModal() {
      return c.version < 2;
    },

    get gtagsEnabled() {
      return 1 === c.marketing;
    },

    savePreferences: function savePreferences(e) {
      if (c.version = 2, c.marketing = e ? 1 : 0, this.config.onMarketingChanged(e), !e) {
        var n,
            o = r(this.config.cookies.marketing);

        try {
          for (o.s(); !(n = o.n()).done;) {
            var t = n.value;
            a.a.remove(t.name, {
              domain: this.config.cookieDomain
            });
          }
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
      }

      a.a.set("consent", c, {
        expires: this.config.cookieExpiration,
        path: "/",
        secure: "https:" === window.location.protocol,
        samesite: "lax"
      });
    },
    bootstrapIfEnabled: function bootstrapIfEnabled() {
      this.gtagsEnabled && this.config.bootstrapMarketing();
    }
  },
      s = {
    title: {
      de: "Datenschutzeinstellungen",
      en: "Privacy settings"
    },
    modalBody: {
      de: "Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Bitte treffen Sie nachfolgend eine Auswahl:",
      en: "We use cookies to make our website optimal for you and to continuously improve it. Please make a selection below:"
    },
    labelNecessary: {
      de: "Notwendig",
      en: "necessary"
    },
    labelMarketing: {
      de: "Marketing",
      en: "marketing"
    },
    headingNecessary: {
      de: "Weitere Infos zu den Notwendigen Cookies",
      en: "More information on necessary cookies"
    },
    paragraphNecessary: {
      de: "Diese Cookies sind für den Betrieb der Webseite unbedingt notwendig und ermöglichen die normale Nutzung der Seite.",
      en: "These cookies are essential for the operation of the website and enable normal use of the page."
    },
    columnHeaderName: {
      de: "Name",
      en: "name"
    },
    columnHeaderProvider: {
      de: "Anbieter",
      en: "provider"
    },
    columnHeaderDescription: {
      de: "Beschreibung",
      en: "description"
    },
    columnHeaderExpires: {
      de: "Ablaufzeitpunkt",
      en: "expires"
    },
    headingMarketing: {
      de: "Weitere Infos zu den Marketing Cookies",
      en: "More information on marketing cookies"
    },
    paragraphMarketing: {
      de: "Um unsere Webseiten-Inhalte und Informationen weiter zu verbessern, erfassen wir anonymisierte Daten für Analysen und Statistiken. Mithilfe der gesetzten Cookies können wir beispielsweise anonymisiert die Anzahl der Besucher und den Effekt bestimmter Seiten des Webauftritts ermitteln und unsere Inhalte so entsprechend optimieren. Ihre Auswahl können Sie jederzeit widerrufen. Einen Link zu diesen Cookie-Einstellungen finden Sie in der",
      en: "In order to further improve our website content and information, we collect anonymized data for analysis and statistics. With the help of the cookies set, we can, for example, anonymously determine the number of visitors and the effect of certain pages on the website and thus optimize our content accordingly. You can revoke your selection at any time. You can find a link to these cookie settings in the"
    },
    privacyLinkText: {
      de: "Datenschutzerklärung",
      en: "data privacy statement"
    },
    confirmButtonText: {
      de: "Auswahl bestätigen",
      en: "confirm selection"
    },
    confirmAllButtonText: {
      de: "Alle bestätigen",
      en: "confirm all"
    },
    siteNoticeLinkText: {
      de: "Impressum",
      en: "site notice"
    }
  };
  var m,
      u = o(1),
      A = o.n(u);

  function f(e) {
    var n = e.isMarketing,
        o = e.cookies,
        t = e.siteNoticeUrl,
        a = e.privacyUrl,
        r = function (e) {
      var n = {};

      for (var o in s) {
        n[o] = s[o][e];
      }

      return n;
    }(l.config.locale);

    return '\n  <div role="dialog" aria-label="Datenschutzeinstellungen"\n       class="d-cc--modal show" aria-modal="true" style="display: block;">\n    <div class="d-cc--modal-dialog d-cc--modal-lg d-cc--modal-dialog-centered d-cc--modal-dialog-scrollable"><span tabindex="0"></span>\n      <div role="document" tabindex="-1" class="d-cc--modal-content">\n        <header class="d-cc--modal-header">\n          <h5 class="d-cc--modal-title">'.concat(r.title, '</h5>\n        </header>\n\n        <div class="d-cc--modal-body">\n          <p>\n            ').concat(r.modalBody, '\n          </p>\n\n          <div class="d-cc--checkboxes">\n            <div>\n              <input id="cb-necessary"\n                     type="checkbox"\n                     disabled="disabled"\n                     autocomplete="off"\n                     checked>\n              <label for="cb-necessary">\n                ').concat(r.labelNecessary, '\n              </label>\n            </div>\n            <div>\n              <input id="cb-marketing"\n                     type="checkbox"\n                     autocomplete="off"\n                     ').concat(n ? "checked" : "", '\n                     >\n              <label\n                  class="custom-control-label" for="cb-marketing">\n                ').concat(r.labelMarketing, '\n              </label>\n            </div>\n          </div>\n\n          <div class="d-cc--accordion" id="d-cc-description">\n            <div class="d-cc--card">\n              <div class="d-cc--card-header" id="headingNecessary">\n                <h2>\n                  <button class="btn btn-link"\n                          type="button"\n                          aria-expanded="false"\n                          aria-controls="necessary"\n                          data-target="#necessary"\n                  >\n                    ').concat(r.headingNecessary, '\n                    <span class="icon-svg">\n                        ').concat(A.a, '\n                    </span>\n                  </button>\n                </h2>\n              </div>\n\n              <div id="necessary" class="d-cc--collapse" style="display: none;" aria-labelledby="headingNecessary">\n                <div class="d-cc--card-body">\n                  <p>\n                    ').concat(r.paragraphNecessary, '\n                  </p>\n                  <table role="table" aria-busy="false" aria-colcount="4" class="table b-table">\n                    <thead role="rowgroup" class="">\n                    <tr role="row" class="">\n                      <th role="columnheader" scope="col" aria-colindex="1" class="">').concat(r.columnHeaderName, '</th>\n                      <th role="columnheader" scope="col" aria-colindex="2" class="">').concat(r.columnHeaderProvider, '</th>\n                      <th role="columnheader" scope="col" aria-colindex="3" class="">').concat(r.columnHeaderDescription, '</th>\n                      <th role="columnheader" scope="col" aria-colindex="4" class="">').concat(r.columnHeaderExpires, '</th>\n                    </tr>\n                    </thead>\n                    <tbody role="rowgroup">\n                    ').concat(o.necessary.map(function (e) {
      var n = e.name,
          o = e.provider,
          t = e.description,
          a = e.expires;
      return '\n                      <tr role="row" class="">\n                        <td aria-colindex="1" role="cell" class="">'.concat(n, '</td>\n                        <td aria-colindex="2" role="cell" class="">').concat(o, '</td>\n                        <td aria-colindex="3" role="cell" class="">').concat(t, '</td>\n                        <td aria-colindex="4" role="cell" class="">').concat(a, "</td>\n                      </tr>\n                    ");
    }).join(""), '\n                    </tbody>\n                  </table>\n\n                </div>\n              </div>\n            </div>\n            <div class="d-cc--card">\n              <div class="d-cc--card-header" id="headingMarketing">\n                <h2>\n                  <button class="btn btn-link"\n                          type="button"\n                          aria-expanded="false"\n                          aria-controls="marketing"\n                          data-target="#marketing"\n                  >\n                    ').concat(r.headingMarketing, '\n                    <span class="icon-svg">\n                        ').concat(A.a, '\n                    </span>\n                  </button>\n                </h2>\n              </div>\n              <div id="marketing" class="d-cc--collapse" style="display: none;" aria-labelledby="headingMarketing">\n                <div class="d-cc--card-body">\n\n                  <p>\n                    ').concat(r.paragraphMarketing, '\n                    \x3c!--suppress HtmlUnknownTarget --\x3e\n                      <a href="/datenschutz" class="">\n                      ').concat(r.privacyLinkText, '\n                    </a>.\n                  </p>\n\n                  <table role="table" aria-busy="false" aria-colcount="4" class="table b-table">\n                    <thead role="rowgroup" class="">\n                    <tr role="row" class="">\n                      <th role="columnheader" scope="col" aria-colindex="1" class="">').concat(r.columnHeaderName, '</th>\n                      <th role="columnheader" scope="col" aria-colindex="2" class="">').concat(r.columnHeaderProvider, '</th>\n                      <th role="columnheader" scope="col" aria-colindex="3" class="">').concat(r.columnHeaderDescription, '</th>\n                      <th role="columnheader" scope="col" aria-colindex="4" class="">').concat(r.columnHeaderExpires, '</th>\n                    </tr>\n                    </thead>\n                    <tbody role="rowgroup">\n                    ').concat(o.marketing.map(function (e) {
      var n = e.name,
          o = e.provider,
          t = e.description,
          a = e.expires;
      return '\n                      <tr role="row" class="">\n                        <td aria-colindex="1" role="cell" class="">'.concat(n, '</td>\n                        <td aria-colindex="2" role="cell" class="">').concat(o, '</td>\n                        <td aria-colindex="3" role="cell" class="">').concat(t, '</td>\n                        <td aria-colindex="4" role="cell" class="">').concat(a, "</td>\n                      </tr>\n                    ");
    }).join(""), '\n                    </tbody>\n                  </table>\n\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <footer class="d-cc--modal-footer">\n          <div>\n\n            <button type="button"\n                    id="d-cc--confirm"\n                    class="btn btn-default"\n\n            >\n              ').concat(r.confirmButtonText, '\n            </button>\n            <button type="button"\n                    class="d-cc-btn-success btn btn-success"\n              id="d-cc--confirm-all"\n            >\n              ').concat(r.confirmAllButtonText, '\n          </button>\n          </div>\n\n          <div>\n            <a href="').concat(t, '"> ').concat(r.siteNoticeLinkText, '</a>\n            <a href="').concat(a, '">').concat(r.privacyLinkText, '</a>\n          </div>\n        </footer>\n      </div>\n      <span tabindex="0"></span></div>\n  </div>\n  <div class="d-cc--modal-backdrop"></div>\n');
  }

  function h() {
    document.querySelectorAll(".d-cc--accordion .d-cc--collapse").forEach(function (e) {
      e.style.display = "none";
    });
  }

  function b() {
    (m = document.createElement("div")).style.position = "absolute", m.style.display = "none", m.style.zIndex = "1040", m.innerHTML = f({
      cookies: l.config.cookies,
      isMarketing: l.gtagsEnabled,
      siteNoticeUrl: l.config.siteNoticeUrl,
      privacyUrl: l.config.privacyUrl
    }), m.querySelectorAll(".d-cc--accordion button").forEach(function (e, n, o) {
      e.addEventListener("click", function () {
        var n = m.querySelector(e.dataset.target);
        "none" === n.style.display ? (h(), n.style.display = "block") : (h(), n.style.display = "none");
      });
    }), m.querySelector("#d-cc--confirm-all").addEventListener("click", function () {
      document.getElementById("cb-marketing").checked = !0, l.savePreferences(!0), m.style.display = "none";
    }), m.querySelector("#d-cc--confirm").addEventListener("click", function () {
      var e = document.getElementById("cb-marketing").checked;
      l.savePreferences(e), m.style.display = "none";
    }), document.body.appendChild(m);
  }

  function p() {
    m || b(), m.style.display = "block";
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (l.config.enabled) {
      var e = document.getElementById("d-cc--show");

      if (e && e.addEventListener("click", p), l.mustShowModal) {
        if (location.href.endsWith(l.config.siteNoticeUrl) || location.href.endsWith(l.config.privacyUrl)) return;
        p();
      } else l.bootstrapIfEnabled();
    }
  });
}]);